import { ConsoleLoggerAdapter, isDev, Logger } from '@capsicum/common';

import { SentryWebService } from '../sentry/sentry.service';

export const setupLogger = () => {
	const sentryClient = new SentryWebService();

	const loggerClient = new ConsoleLoggerAdapter(isDev() ? 'debug' : 'quite');

	const logger = Logger.setClientLogger(loggerClient).addErrorLogger(sentryClient);

	return logger;
};
